import React from "react";
import BreadCrumbs from "../../../../layout/BreadCrumbs";

const Accounts = () => {
  return (
    <div className="accounts-page">
      <BreadCrumbs
        data={[
          { name: "Settings", link: "/manage" },
          { name: "Configure", link: "/manage/config" },
          { name: "Accounts", link: "/admin/config/accounts" },
        ]}
      />
    </div>
  );
};

export default Accounts;
